export default __webpack_public_path__ + "static/media/24H_Red_Black.9f9a9647.png";